module.exports = __webpack_public_path__ + "static/media/flow-partner-en.63bd69cf.png";